import { inject, signal } from '@angular/core';
import { HttpErrorService, MembershipsService } from '../../services';
import { MessageService } from 'primeng/api';
import { Membership, MembershipCollection } from '../../models';
import { Router } from '@angular/router';
import { PublicRoutes } from '../../enums';

/** when extending this class be sure to implement ngOnInit, getImageSrc, sortCollections, sortMemberships */
export abstract class NgxAimMembershipsClass {
  // ngOnInit(): void {
  //   this.init();
  // }

  membershipsService = inject(MembershipsService);
  httpErrorService = inject(HttpErrorService);
  messageService = inject(MessageService);
  router = inject(Router);

  individualMemberships = signal<MembershipCollection[]>([]);
  groupMemberships = signal<MembershipCollection[]>([]);

  isLoading = signal(false);

  init(): void {
    this.getMemberships();
  }

  getMemberships() {
    this.isLoading.set(true);
    this.membershipsService.getMemberships().subscribe({
      next: (memberships) => this.onGetMembershipsSuccess(memberships),
      error: (err) => this.onFailure(err),
    });
  }

  onGetMembershipsSuccess(memberships: Membership[]) {
    const individualTierGroups = new Set<string>();
    const groupTierGroups = new Set<string>();
    const individualMemberships: Membership[] = [];
    const groupMemberships: Membership[] = [];

    for (const membership of memberships) {
      if (membership.IsGroup) {
        groupTierGroups.add(membership.TierGroup);
        groupMemberships.push(membership);
      } else {
        individualTierGroups.add(membership.TierGroup);
        individualMemberships.push(membership);
      }
    }

    const individualMembershipCollections: MembershipCollection[] = [];
    for (const tier of individualTierGroups) {
      const filteredMemberships = individualMemberships.filter((membership) => membership.TierGroup === tier);
      individualMembershipCollections.push({
        TierGroup: tier,
        memberships: filteredMemberships.sort(this.sortMemberships),
        imageSrc: this.getImageSrc(tier),
        InitiationPrice: filteredMemberships[0].InitiationPrice,
      });
    }
    this.individualMemberships.set(individualMembershipCollections.sort(this.sortCollections));

    const groupMembershipCollections: MembershipCollection[] = [];
    for (const tier of groupTierGroups) {
      const filteredMemberships = groupMemberships.filter((membership) => membership.TierGroup === tier);
      groupMembershipCollections.push({
        TierGroup: tier,
        memberships: filteredMemberships.sort(this.sortMemberships),
        imageSrc: this.getImageSrc(tier),
        InitiationPrice: filteredMemberships[0].InitiationPrice,
      });
    }
    this.groupMemberships.set(groupMembershipCollections.sort(this.sortCollections));

    this.isLoading.set(false);
  }

  onMembershipClick(membership: Membership) {
    this.membershipsService.selectedMembership = membership;
    this.router.navigateByUrl(`/${PublicRoutes.MEMBERSHIPS}/${PublicRoutes.CHECKOUT}`);
  }

  onFailure(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load memberships');
  }

  abstract getImageSrc(TierGroup: string): string;
  abstract sortCollections(a: MembershipCollection, b: MembershipCollection): number;
  abstract sortMemberships(a: Membership, b: Membership): number;
}
